import request from '@/utils/request'

export const sampleApi = {
  list(data) {
    return request({
      url: '/inventory-management-api/sample/list',
      method: 'POST',
      data
    })
  },

  detail(id) {
    return request({
      url: '/inventory-management-api/sample/detail',
      method: 'POST',
      data: { id }
    })
  },

  create(data) {
    return request({
      url: '/inventory-management-api/sample/create',
      method: 'POST',
      data
    })
  },

  update(data) {
    return request({
      url: '/inventory-management-api/sample/update',
      method: 'POST',
      data
    })
  },

  delete(id) {
    return request({
      url: '/inventory-management-api/sample/delete',
      method: 'POST',
      data: { id }
    })
  }
}
